/**
 * Browser style utilities for boba-cli demos.
 * Provides a StyleContext with full color support for xterm.js.
 */

import { createAlwaysEnabledStyle } from '@boba-cli/machine'
import { Style, setDefaultContext, type StyleContext } from '@boba-cli/chapstick'
import type { EnvironmentAdapter, ColorSupport } from '@boba-cli/machine'

// Browser environment adapter with full color support
const browserEnv: EnvironmentAdapter = {
  get: () => undefined,
  getColorSupport: (): ColorSupport => ({
    level: 3,
    hasBasic: true,
    has256: true,
    has16m: true,
  }),
  getTerminalBackground: () => 'dark' as const,
}

// Style context for browser with full color support
const browserStyleContext: StyleContext = {
  env: browserEnv,
  styleFn: createAlwaysEnabledStyle(),
}

// Set the global default context so all Style instances (including those
// created internally by components) will use browser colors
setDefaultContext(browserStyleContext)

/**
 * Create a new Style with browser color support.
 */
export function createStyle(): Style {
  return new Style({}, undefined, browserStyleContext)
}

